import { Component, OnInit } from '@angular/core';
import { Alerts } from 'src/app/core/Constants/alert';
import { Toast } from 'src/app/core/Models/interfaces/alert&toast';
import { ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.css']
})
export class ToasterComponent implements OnInit {
  public iconClass: { [key: string]: string } = Alerts.alertClass;
  public toastMessage: any;
  public btnShow = false;
  constructor(private toastService: ToasterService) { }
  ngOnInit(): void {
    
    this.toastService.toasterTigger$.subscribe((toast: Toast) => {
      if (!toast.title) {
        return;
      }
      this.toastMessage = toast;
      setTimeout(() => {
        this.makeToastEmpty(this.toastMessage);
      },7000);
    });

   
  }

  makeToastEmpty(toast: Toast) {
    this.toastMessage= null;
  }
}
